<template>
	<QuillEditor theme="snow"
				 id="quiiEditorComponent"
				 :options="editorOption"
				 ref="quillEditor"
				 :style="this.style"
				 @ready="onEditorReady($event)"
				 :toolbar="this.toolbarOpt" />
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import s3 from "@/api/s3/admin_s3";

import {
	fnToString,
} from '@/common/commonScript'

export default {
	name: 'quillEditor',
	data() {
		let self = this;
		return {
			editorOption: {
				placeholder : "내용을 입력해주세요.",
				imageResize: true,
        formats: ['bold','italic'],
			},
			toolbarOpt : {
				container: [
					[
						'bold',
						'italic',
						'underline',
						'strike',
						'blockquote',
						'code-block'
					], // toggled buttons
					[
						{ 'header': 1 },
						{ 'header': 2 }
					], // custom button values
					[
						{ 'list': 'ordered'},
						{ 'list': 'bullet' }
					],
					[
						{ 'script': 'sub'},
						{ 'script': 'super' }
					], // superscript/subscript
					[
						{ 'indent': '-1'},
						{ 'indent': '+1' },
						{ 'direction': 'rtl' }
					], // outdent/indent
					[
						{ 'size': ['small', false, 'large', 'huge'] },
						{ 'header': [1, 2, 3, 4, 5, 6, false] }
					],  // custom dropdown
					[
						{ 'color': [] },
						{ 'background': [] },
						{ 'font': [] },
						{ 'align': [] }
					],
					[
						'image'
					],
					[
						'link',
						'video',
						'clean'
					]
				],
				handlers: {
					'image': function (value) {
						if (value) {
							/* input 태그 생성 */
							let input = document.createElement("input");
							input.type = "file";
							input.ref = "image";
							input.accept = "image/*";
							input.addEventListener("change", self.uploadImg);

							input.click();
						}
					}
				},
			},

			quillModel : this.model,
			quill : "",

			imgFile : {},
			quillImgList : this.imgList,
			quillReplaceSrc : this.replaceSrc,
			quillImgCnt : 0,
		}
	},
	props: [
		"model",
		"name",
		"componentName",
		"style",
		/* 아래는 이미지 관련 */
		"imgList",
		"replaceSrc",	// 이미지 넘길때 replace할 목록
	],
	components: {
		QuillEditor
	},
	computed: {
		editor() {
			return this.$refs.quillEditor.quill
		}
	},
	methods: {
		onEditorReady(editor) {
			// 처음 로드 시 값이 없거나 undefined일때 초기화
			if( fnToString(editor.root.innerText) == "" ){
				editor.root.innerHTML = fnToString(this.quillModel) == "" ? "<p></p>" : this.quillModel
			}
		},
		uploadImg: function(e){
			/* 20220530 조은성 주석처리 (image 업로드 저장버튼 누를때 실행하도록 하는부분인데 save/update문제가 있어 우선 주석처리.... 이미지 업로드 할때 바로 업로드하도록 처리..) */
			// console.log(this.$refs.quillEditor.getQuill());
			// // console.log(this.$refs.quillEditor.getQuill().selection.getRange()[0].index);
			// this.quillImgList[0][this.quillImgCnt] = e.target.files[0];

			// let imgUrl = URL.createObjectURL(e.target.files[0]);
			// // let range = this.$refs.quillEditor.getQuill().selection.getRange()[0];

			// this.quillReplaceSrc[0][this.quillImgCnt] = 'src="' + imgUrl + '"';
			// // this.$refs.quillEditor.getQuill().insertEmbed(range.index , 'image', "https://ajmtp-gocha.s3.ap-northeast-2.amazonaws.com/20220524-125700_board_20220524125657_1_ios.jpg");
			// // this.$refs.quillEditor.getQuill().insertEmbed(range.index , 'image', imgUrl);
			// // this.$refs.quillEditor.getQuill().pasteHTML(range.index , "<img id='quillImg_" + this.quillImgCnt + "' src='" + imgUrl + "'/>");
			// this.$refs.quillEditor.getQuill().root.innerHTML += "<p><img id='quillImg_" + this.quillImgCnt + "' src='" + imgUrl + "'/></p>"
			// this.quillImgCnt += 1;

			const formData = new FormData();
			formData.append("editorImg", e.target.files[0]);
			s3.uploadEditorImage( formData )
				.then(
						(response) => {
							if( response.data.statusCode == 1 ){
								console.log("uploadList ==> ", response);
                let range = this.$refs.quillEditor.getQuill().selection.getRange()[0];
                this.$refs.quillEditor.getQuill().insertEmbed(range.index , 'image', response.data.data.list[0].filePath);
							}
						}
				)
				.catch((error) => console.log(error))
		},
	},
	created() {
		// this.quillImgList.push({});
		// this.quillReplaceSrc.push({})
	}
}
</script>

<style>
	.ql-editor{
		min-height: inherit;
	}
</style>
